<template>
  <div class="channel-list">
    <div class="title">指标</div>
    <div class="target">
      <!-- <el-scrollbar style="max-height: 18vw;"> -->
      <ul>
        <li
          v-for="(item, index) in channelData"
          :key="'channelList' + index"
          :value="item.ChannelID"
          @click="clickHandler(index, item)"
        >
          <a
            :class="{
              active: index === curIndex || item[textField] === curText,
            }"
            >{{ item[textField] }}</a
          >
        </li>
      </ul>
      <!-- </el-scrollbar> -->
    </div>
  </div>
</template>
<script>
export default {
  props: {
    channelData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    //可以设置使用channelData中的哪个属性名称来显示
    textField: {
      type: String,
      default: "text",
    },
    defaultIndex: {
      type: Number,
      default: undefined,
    },
    defaulText: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      curIndex: undefined,
      curText: undefined,
    };
  },
  mounted() {
    this.setDefault();
  },
  methods: {
    setDefault() {
      this.curIndex = this.defaultIndex;
      this.curText = this.defaulText;
    },
    clickHandler(index, item) {
      this.curIndex = index;
      this.curText = item[this.textField];
      //抛出一个事件，点击后可执行，参数为，当前点击的序号，以及对应的data中item
      if (this.$listeners["item-click"]) {
        this.$emit("item-click", index, item);
      }
    },
    getSelectedIndex() {
      return this.curIndex;
    },
  },
};
</script>
<style lang="less" scoped>
* {
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -o-box-sizing: border-box;
  -ms-box-sizing: border-box;
}
ul,
li,
span,
p,
h1,
h2,
h3,
h4,
h5,
h6,
a,
dl,
dt,
dd,
input {
  padding: 0;
  margin: 0;
  list-style: none;
  text-decoration: none;
  font-weight: normal;
  font-style: normal;
  font-family: "Microsoft yahei";
}
.channel-list {
  position: absolute;
  left: 0.7vw;
  top: 20px;
}
.target {
  color: #fff;
  // max-height: 35vh;
  li a {
    color: #fff;
  }
}
.target ul {
  border: 1px solid rgba(106, 106, 106, 0.2);
  border-radius: 0.35vw;
  border-top: 0;
  width: 6.5vw;
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 0.35vw;
  font-size: 0.44vw;
}
// .el-scrollbar {
// 	.el-scrollbar__wrap {
// 		max-height: 300px; // 最大高度
// 		overflow-x: hidden; // 隐藏横向滚动栏
// 	}
// }
.target ul li {
  width: 6.5vw;
  height: 1.9vw;
  word-break: keep-all;
}
.target ul li > a {
  display: block;
  line-height: 1.5vw;
  cursor: pointer;
  text-align: center;
}

.target ul li > a:hover,
.target ul li > a:focus,
.target ul li > a:active {
  background: rgba(0, 245, 245, 0.15);
  color: #00f5f5;
}

.target ul li > a:hover,
.target ul li > a:focus,
.target ul li > a:active {
  background: rgba(0, 245, 245, 0.15);
  color: #00f5f5;
}

// .target ul li:first-child a {
//   border-radius: 0.35vw 0.35vw 0 0;
//   background: rgba(255, 255, 255, 0.56);
//   color: #000;
// }
.active {
  background: rgba(0, 245, 245, 0.15);
  color: #00f5f5 !important;
}
/deep/.el-scrollbar__wrap {
  overflow-x: hidden;
  max-height: 35vh;
  height: unset;
  margin-bottom: 0 !important;
}

.title {
  font-size: 0.44vw;
  border-radius: 0.35vw 0.35vw 0 0;
  background: rgba(0, 245, 245, 0.5);
  color: #fff;
  width: 6.5vw;
  height: 1.5vw;
  line-height: 1.5vw;
  border: 1px solid rgba(106, 106, 106, 0.2);
  border-bottom: 0;
  text-align: center;
}
</style>